import { Col } from "@tremor/react";
import { Link } from "react-router-dom";

// Summary of the user's ανακοπές that still need an αίτηση επαναπροσδιορισμού
// (Ν. 5221/2025), from the backend's `epanaprosdiorismos` status on each case.
const formatIso = (iso) => (iso ? iso.split("-").reverse().join(".") : "");

export default function EpanaprosdiorismosBanner({ cases, columns = 1 }) {
  const pending = (cases ?? []).filter(
    (c) =>
      c?.epanaprosdiorismos?.role === "old" &&
      c.epanaprosdiorismos.status === "pending"
  );
  if (pending.length === 0) return null;

  const deadlines = [
    ...new Set(pending.map((c) => c.epanaprosdiorismos.deadline)),
  ].sort();
  const nearest = deadlines[0];
  const dueNearest = pending.filter(
    (c) => c.epanaprosdiorismos.deadline === nearest
  ).length;

  return (
    <Col numColSpan={columns} className="epan-alert" role="alert">
      <span className="epan-alert__label">
        <span aria-hidden="true">⚠</span> Επαναπροσδιορισμός ανακοπών (Ν.
        5221/2025)
      </span>
      <span className="epan-alert__result">
        {pending.length === 1
          ? "1 ανακοπή χρειάζεται αίτηση επαναπροσδιορισμού"
          : `${pending.length} ανακοπές χρειάζονται αίτηση επαναπροσδιορισμού`}
        {` · ${dueNearest} με προθεσμία έως ${formatIso(nearest)}`}
      </span>
      <span className="epan-alert__meta">
        Αν δεν κατατεθεί αίτηση, η ανακοπή λογίζεται ως μη ασκηθείσα.{" "}
        <Link to="/astika?epan=pending">Δείτε τις υποθέσεις</Link>
      </span>
    </Col>
  );
}
